<template>
  <div>
    <nav id="nav">
      <!-- pc端 -->
      <div id="pc" class="main-container clearfix">
        <div class="logo f-left g-flex flex-align-cen" @click="backHome">
          <img src="static/images/logo.png" alt="" title="logo" />
        </div>
        <div
          class="search  f-left g-flex flex-center flex-align-cen"
          ref="nav-search"
        >
          <input type="text" @focus="alertSearch" placeholder="搜索..." />
          <img
            class="icon"
            src="static/images/icon_search.png"
            @click="alertSearch"
          />
        </div>
        <div class="nav-tab f-left g-pos-r">
          <ul class="tab-list  g-flex">
            <li class="tab" :class="{ active: tabActive === 'tab1' }">
              <a
                ref="tab1"
                @click="router('overview', 'tab1')"
                @mouseenter="mouseenter('tab1')"
                @mouseout="mouseout"
                >剧院概览</a
              >
            </li>
            <li class="tab" :class="{ active: tabActive === 'tab2' }">
              <a
                ref="tab2"
                @click="router('news', 'tab2')"
                @mouseenter="mouseenter('tab2')"
                @mouseout="mouseout"
                >新闻动态</a
              >
            </li>
            <li class="tab" :class="{ active: tabActive === 'tab3' }">
              <a
                ref="tab3"
                @click="router('center', 'tab3')"
                @mouseenter="mouseenter('tab3')"
                @mouseout="mouseout"
                >演出中心</a
              >
            </li>
            <li class="tab" :class="{ active: tabActive === 'tab4' }">
              <a
                ref="tab4"
                @click="router('cloudTheater', 'tab4')"
                @mouseenter="mouseenter('tab4')"
                @mouseout="mouseout"
                >5G剧场</a
              >
            </li>
            <li class="tab" :class="{ active: tabActive === 'tab5' }">
              <a
                ref="tab5"
                @click="router('education', 'tab5')"
                @mouseenter="mouseenter('tab5')"
                @mouseout="mouseout"
                >艺术教育</a
              >
            </li>
            <li class="tab" :class="{ active: tabActive === 'tab6' }">
              <a
                ref="tab6"
                @click="router('goods', 'tab6')"
                @mouseenter="mouseenter('tab6')"
                @mouseout="mouseout"
                >文创产品</a
              >
            </li>
            <li class="tab" :class="{ active: tabActive === 'tab7' }">
              <a
                ref="tab7"
                @click="router('cooperation', 'tab7')"
                @mouseenter="mouseenter('tab7')"
                @mouseout="mouseout"
                >商务合作</a
              >
            </li>
          </ul>
          <span
            class="tab-hover g-pos-a"
            :style="{ width: hover.width, left: hover.left }"
          ></span>
        </div>
        <div class="cat f-right g-flex flex-center flex-col" @click="showCat">
          <div class=" g-flex flex-col flex-align-cen">
            <div class="imgbox">
              <img src="static/images/icon_shopping_cat.png" alt="" />
              <p v-if="catListNumber > 0" class="cat-num">
                {{ catListNumber }}
              </p>
            </div>
            <p>购物车</p>
          </div>
        </div>
        <div
          class="user f-right g-flex flex-center flex-col"
          @click="showAdmin"
        >
          <div class="g-flex flex-col flex-align-cen">
            <img src="static/images/icon_personal.png" alt="" />
            <p>个人中心</p>
          </div>
        </div>
      </div>
      <!-- 搜索 -->
      <div
        ref="search-section"
        class="search-section"
        :class="{ show: sectionShow }"
        :style="{ left: sectionLeft }"
      >
        <div class="con">
          <input type="text" v-model="searchQuery.search" placeholder="搜索..." />
          <img
            class="close"
            src="static/images/icon_delete.png"
            alt=""
            @click="closeSearch"
          />
          <img
            class="search"
            src="static/images/icon_search.png"
            alt=""
            @click="search"
          />
          <div class="main-container" :class="{ active: searchActive }">
            <div v-if="!searchIsFind" class="no-find">
              <p>抱歉，没有找到相关的内容</p>
              <!-- <p class="">您可能感兴趣的</p>
              <ul class="list">
                <li class="item g-flex">
                  <div class="imgbox g-flex flex-center flex-align-cen">
                    <img src="/static/images/center_test.png" alt="">
                  </div>
                  <div class="right">
                    <p class="title .overflow-clamp2">打开防静电</p>
                    <p class="desc overflow-clamp2" > 发的发生范德萨</p>
                  </div>
                </li>
              </ul> -->
            </div>
            <div v-else class="find">
              <ul class="list">
                <li class="item g-flex" v-for="(item,index) in searchList" :key="index" @click="toArticle(item)">
                  <div class="imgbox g-flex flex-center flex-align-cen">
                    <img v-if="item.article_thumb_path&&item.article_thumb_path!==''" src="item.article_thumb_path" alt="">
                    <img v-else src="/static/images/news_default.png" alt="">
                  </div>
                  <div class="right">
                    <p class="title .overflow-clamp2">{{item.article_name}}</p>
                    <p class="desc overflow-clamp2" >{{item.article_desc}}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 手机端 -->
      <div id="mobile" class="main-container"></div>
    </nav>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { postAdmin, postSearch } from '@/api/main.js'
export default {
  components: {},
  computed: {
    ...mapState({
      isLogin: state => state.isLogin,
      token: state => state.token,
      tabActive: state => state.tabActive,
      loginOrReginter: state => state.loginOrReginter,
      catListNumber: state => state.cat.catListNumber,
      formVisible: state => state.formVisible
    })
  },
  data() {
    return {
      hover: {
        width: '0px',
        left: '0px'
      },
      sectionShow: false,
      sectionLeft: '0px',
      toAdmin: 'admin', // 是否登录完后调整admin
      searchActive: false,
      searchQuery: {
        search: '',
        page: 1
      },
      searchIsFind: true,
      searchList: []
    }
  },
  created() {
    this.init()
  },
  watch: {
    tabActive: {
      handler(newVal) {
        if (newVal == '') {
          this.mouseout()
        }
      }
    }
  },
  mounted() {
    var obj = this.$refs['nav-search']
    this.sectionLeft = obj.offsetLeft + 'px'
  },
  methods: {
    ...mapMutations([
      'setTabActive',
      'setLogin',
      'setToRouter',
      'setFormVisible'
    ]),
    // 数据初始化
    init() {
      const self = this
      if (this.tabActive !== '') {
        this.$nextTick(function() {
          self.hover.left = self.$refs[self.tabActive].offsetLeft + 'px'
          self.hover.width = self.$refs[self.tabActive].clientWidth + 'px'
        })
      }
    },
    // 开启搜索框
    alertSearch() {
      this.sectionShow = true
      this.sectionLeft = '0px'
    },
    // 关闭搜索框
    closeSearch() {
      var obj = this.$refs['nav-search']
      this.sectionLeft = obj.offsetLeft + 'px'
      this.sectionShow = false
      this.searchActive = false
    },
    // 搜索
    search() {
      this.searchActive = true
      postSearch(this.searchQuery)
        .then(res => {
          const resData = res.data.data
          if (resData.length > 0) {
            this.searchList = resData
            this.searchIsFind = true
          } else {
            this.searchIsFind = false
          }
        })
        .catch(err => {
          console.log('搜索失败', err)
        })
    },
    // tab hover in
    mouseenter(tab) {
      const self = this
      this.$nextTick(function() {
        self.hover.left = self.$refs[tab].offsetLeft + 'px'
        self.hover.width = self.$refs[tab].clientWidth + 'px'
      })
    },
    // tab hover out
    mouseout() {
      const self = this
      if (this.tabActive !== '') {
        this.$nextTick(function() {
          self.hover.left = self.$refs[self.tabActive].offsetLeft + 'px'
          self.hover.width = self.$refs[self.tabActive].clientWidth + 'px'
        })
      } else {
        this.$nextTick(function() {
          self.hover.left = '0px'
          self.hover.width = '0px'
        })
      }
    },
    // 是否跳转个人中心
    showAdmin() {
      postAdmin({ token: this.token }).then(res => {
        if (res.data.code == 200) {
          if (this.$route.path == '/admin') {
            return false
          }
          this.setTabActive('')
          this.$router.push('/admin')
        } else {
          this.setFormVisible(true)
          this.setToRouter('/admin')
        }
      })
    },
    // 跳转购物车
    showCat() {
      postAdmin({ token: this.token }).then(res => {
        if (res.data.code == 200) {
          if (this.$route.path == '/cat') {
            return false
          }
          this.setTabActive('')
          this.$router.push('/cat')
        } else {
          this.setFormVisible(true)
          this.setToRouter('/cat')
        }
      })
    },
    // 页面跳转
    router(page, tab) {
      this.$router.push('/' + page)
      this.setTabActive(tab)
    },
    // 返回首页
    backHome() {
      this.$router.push('/index')
      this.setTabActive('')
      this.mouseout()
    },
    // 跳转新闻详情
    toArticle(item) {
      this.searchActive = false
      this.closeSearch()
      this.$router.push({
        path: '/news/detail',
        query: { article_id: item.id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-section {
  .main-container {
    width: 100%;
    height: 0;
    overflow: hidden;
  }
  .main-container.active {
    height: auto;
    transition: all 1s;
  }
  .list {
    .item {
      height: 110px;
      padding: 15px 0;
      cursor: pointer;
      border-bottom: 1px solid #eee;
      .imgbox {
        width: 30%;
        height: 80px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .right {
        width: 70%;
        .title {
          font-size: 16px;
          font-weight: bold;
          line-height: 20px;
          color: #333;
        }
        .desc {
          margin-top: 4px;
          font-size: 14px;
          line-height: 18px;
        }
      }
      font-size: 14px;
      color: #666;
    }
  }
  .no-find {
    font-size: 14px;
    margin: 20px 0;
    > p {
      margin: 20px 0;
    }
  }
}
#nav {
  height: 100px;
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  box-sizing: border-box;
}

.main-container {
  margin: 0 auto;
  width: 1200px;
}
#pc {
  height: 100%;
}

#nav #mobile {
  display: none;
}

#nav #pc {
  display: block;
  min-width: 1200px;
  overflow: hidden;
}

#nav #pc .logo {
  height: 100%;
  margin-right: 10px;
}

#nav #pc .search {
  height: 100%;
  width: 160px;
  border-width: 0 1px;
  border-style: solid;
  border-color: #dfdfdf;
}

#nav #pc .search input {
  height: 70px;
  width: 88px;
  font-size: 18px;
  color: #999;
  line-height: 70px;
  border-bottom: 2px solid #333;
}

#nav #pc .search .icon {
  display: block;
  width: 24px;
  height: 25px;
  cursor: pointer;
}

#nav #pc .nav-tab {
  height: 100%;
}

#nav #pc .nav-tab .tab-list {
  height: 100%;
  padding: 0 5px;
}

#nav #pc .nav-tab .tab {
  height: 100%;
  cursor: pointer;
  user-select: none;
}

#nav #pc .nav-tab .tab > a {
  display: block;
  height: 97;
  line-height: 96px;
  font-size: 18px;
  font-weight: bold;
  color: #666;
  margin: 0 15px;
  border-bottom: 1px solid transparent;
}

#nav #pc .nav-tab .tab.active > a {
  color: #e71122;
  border-bottom: 1px solid #e71122;
}

#nav #pc .nav-tab .tab-hover {
  width: 72px;
  height: 3px;
  left: 20px;
  bottom: 1px;
  background: #e71122;
  transition: all 1s;
}

#nav #pc .cat,
#nav #pc .user {
  width: 81px;
  height: 100%;
  font-size: 14px;
  color: #999;
  border-left: 1px solid #dfdfdf;
  cursor: pointer;
  user-select: none;
}

#nav #pc .cat > div > p,
#nav #pc .user > div > p {
  margin-top: 16px;
}

#nav #pc .cat .imgbox {
  width: 20px;
  height: 18px;
  position: relative;
}

#nav #pc .cat .imgbox .cat-num {
  padding: 0 5px;
  width: auto;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  border-radius: 8px;
  background-color: #e71122;
  color: #fff;
  position: absolute;
  top: -8px;
  right: 0px;
  transform: translateX(100%) translateX(-8px);
}

#nav .search-section {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 160px;
  height: 100px;
  background-color: #fff;
  opacity: 0;
  overflow: hidden;
  z-index: -1;
  transition: all 1s;
}

#nav .search-section.show {
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9;
  opacity: 1;
  transition: all 1s;
}

#nav .search-section .con {
  position: relative;
  width: 33%;
  height: 100px;
  border-bottom: 1px solid #333;
  margin: 0 auto;
  transition: all 1s;
}

#nav .search-section.show .con {
  height: 61px;
  margin-top: 200px;
  transition: all 1s;
}

#nav .search-section .con input {
  width: 100%;
  height: 100%;
  font-size: 18px;
  line-height: 60px;
}

#nav .search-section .con .close {
  position: absolute;
  right: 0;
  bottom: 160px;
  cursor: pointer;
}

#nav .search-section .con .search {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/nav/index.vue